module.exports = __webpack_public_path__ + "img/fontItalicWhite.abb26f5d.svg";